import { URLS, createJurisdictionHeaders } from '@/data';
import { Event, Market, Option } from '@/feature/event-details-sbk/types';

// an option is only addressable via its market and that market's event; the backend 404s on a mismatch
export type SelectionRef = {
    event_id: string;
    market_id: string;
    option_id: string;
};

export type ResolvedSelection = {
    event_id: string;
    market: Market;
    option: Option;
};

// response is NOT wrapped in the usual { data } envelope (see backend SelectionController)
export type ResolveSelectionsResponse = {
    events: Event[];
    selections: ResolvedSelection[];
};

// resolution is all-or-nothing: one unknown option id fails the whole request
export class SelectionsNotFoundError extends Error {
    constructor() {
        super('One or more selections could not be found');
        this.name = 'SelectionsNotFoundError';
    }
}

export const resolveSelections = async (selections: SelectionRef[]): Promise<ResolveSelectionsResponse> => {
    const response = await fetch(`${URLS.CHAMELON_API_URL}/selections/resolve`, {
        method: 'POST',
        headers: {
            ...createJurisdictionHeaders(),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ selections }),
    });
    const data = await response.json();
    if (!response.ok) {
        if (response.status === 404) {
            throw new SelectionsNotFoundError();
        }
        throw data;
    }
    return data;
};
